export const DAY_AND_MONTH_FORMAT = 'D MMMM';
export const DAY_MONTH_AND_YEAR_FORMAT = 'D MMMM yyyy';
